// Constants
import ColumnName from '../column-name/column-name.constants';
import Kendo from '../../../constants/kendo.constants';

export default {
  columns: [
    {
      ...ColumnName.buttons,
      cell: Kendo.cellTemplateNames.buttons,
      filterable: false,
      minResizableWidth: Kendo.size.minResizableWidth,
      columnMenu: false,
      selected: true,
      selectedLargeView: true,
      width: Kendo.size.width.buttons
    },
    {
      ...ColumnName.CoolantSample.sampleNumber,
      filter: Kendo.filter.numeric,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: true,
      selectedLargeView: true,
      width: Kendo.size.width.long
    },
    {
      ...ColumnName.CoolantSample.sampleSeverityName,
      cell: Kendo.cellTemplateNames.severity,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: true,
      selectedLargeView: true,
      width: Kendo.size.width.small
    },
    {
      ...ColumnName.CoolantSample.dateReceived,
      filter: Kendo.filter.date,
      minResizableWidth: Kendo.size.minResizableWidth,
      selectedLargeView: true,
      width: Kendo.size.width.date
    },
    {
      ...ColumnName.CoolantSample.dateSampled,
      filter: Kendo.filter.date,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: true,
      selectedLargeView: true,
      width: Kendo.size.width.date
    },
    {
      ...ColumnName.CoolantSample.customerName,
      cell: Kendo.cellTemplateNames.customerName,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: true,
      selectedLargeView: true,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.CoolantSample.customerCode,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.CoolantSample.customerThirdParty,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.CoolantSample.unitName,
      cell: Kendo.cellTemplateNames.unit,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: true,
      selectedLargeView: true,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.OilSample.unitTypeName,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.OilSample.manufacturerModelName,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.CoolantSample.fluidName,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: true,
      selectedLargeView: true,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.CoolantSample.fluidManufacturerName,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: true,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.CoolantSample.fluidBrandName,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: true,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.CoolantSample.fluidActionName,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.CoolantSample.fluidActionCode,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.CoolantSample.meterReading,
      filter: Kendo.filter.numeric,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: true,
      selectedLargeView: true,
      width: Kendo.size.width.int
    },
    {
      ...ColumnName.CoolantSample.meterReadingUnitOfMeasureName,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.CoolantSample.milesOrHoursOnSample,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: true,
      selectedLargeView: true,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.CoolantSample.milesOrHoursOnSampleUnitOfMeasureName,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.CoolantSample.comments,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.CoolantSample.customerComments,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.CoolantSample.iron,
      cell: Kendo.cellTemplateNames.severity,
      display: ColumnName.CoolantSample.ironDisplay.field,
      filter: Kendo.filter.numeric,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.int
    },
    {
      ...ColumnName.CoolantSample.aluminum,
      cell: Kendo.cellTemplateNames.severity,
      display: ColumnName.CoolantSample.aluminumDisplay.field,
      filter: Kendo.filter.numeric,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.int
    },
    {
      ...ColumnName.CoolantSample.lead,
      cell: Kendo.cellTemplateNames.severity,
      display: ColumnName.CoolantSample.leadDisplay.field,
      filter: Kendo.filter.numeric,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.int
    },
    {
      ...ColumnName.CoolantSample.copper,
      cell: Kendo.cellTemplateNames.severity,
      display: ColumnName.CoolantSample.copperDisplay.field,
      filter: Kendo.filter.numeric,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.int
    },
    {
      ...ColumnName.CoolantSample.boron,
      cell: Kendo.cellTemplateNames.severity,
      display: ColumnName.CoolantSample.boronDisplay.field,
      filter: Kendo.filter.numeric,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: true,
      selectedLargeView: true,
      width: Kendo.size.width.int
    },
    {
      ...ColumnName.CoolantSample.tin,
      cell: Kendo.cellTemplateNames.severity,
      display: ColumnName.CoolantSample.tinDisplay.field,
      filter: Kendo.filter.numeric,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.int
    },
    {
      ...ColumnName.CoolantSample.phosphorous,
      cell: Kendo.cellTemplateNames.severity,
      display: ColumnName.CoolantSample.phosphorusDisplay.field,
      filter: Kendo.filter.numeric,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.int
    },
    {
      ...ColumnName.CoolantSample.zinc,
      cell: Kendo.cellTemplateNames.severity,
      display: ColumnName.CoolantSample.zincDisplay.field,
      filter: Kendo.filter.numeric,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.int
    },
    {
      ...ColumnName.CoolantSample.calcium,
      cell: Kendo.cellTemplateNames.severity,
      display: ColumnName.CoolantSample.calciumDisplay.field,
      filter: Kendo.filter.numeric,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: true,
      selectedLargeView: true,
      width: Kendo.size.width.int
    },
    {
      ...ColumnName.CoolantSample.magnesium,
      cell: Kendo.cellTemplateNames.severity,
      display: ColumnName.CoolantSample.magnesiumDisplay.field,
      filter: Kendo.filter.numeric,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: true,
      selectedLargeView: true,
      width: Kendo.size.width.int
    },
    {
      ...ColumnName.CoolantSample.molybdenum,
      cell: Kendo.cellTemplateNames.severity,
      display: ColumnName.CoolantSample.molybdenumDisplay.field,
      filter: Kendo.filter.numeric,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: true,
      selectedLargeView: true,
      width: Kendo.size.width.int
    },
    {
      ...ColumnName.CoolantSample.potassium,
      cell: Kendo.cellTemplateNames.severity,
      display: ColumnName.CoolantSample.potassiumDisplay.field,
      filter: Kendo.filter.numeric,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: true,
      selectedLargeView: true,
      width: Kendo.size.width.int
    },
    {
      ...ColumnName.CoolantSample.silicon,
      cell: Kendo.cellTemplateNames.severity,
      display: ColumnName.CoolantSample.siliconDisplay.field,
      filter: Kendo.filter.numeric,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: true,
      selectedLargeView: true,
      width: Kendo.size.width.int
    },
    {
      ...ColumnName.CoolantSample.sodium,
      cell: Kendo.cellTemplateNames.severity,
      display: ColumnName.CoolantSample.sodiumDisplay.field,
      filter: Kendo.filter.numeric,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: true,
      selectedLargeView: true,
      width: Kendo.size.width.int
    },
    {
      ...ColumnName.CoolantSample.color,
      cell: Kendo.cellTemplateNames.severity,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      selectedLargeView: true,
      width: Kendo.size.width.default
    },

    // TODO: Add Clarity
    {
      ...ColumnName.CoolantSample.ph,
      cell: Kendo.cellTemplateNames.severity,
      display: ColumnName.CoolantSample.phDisplay.field,
      filter: Kendo.filter.numeric,
      minResizableWidth: Kendo.size.minResizableWidth,
      selectedLargeView: true,
      width: Kendo.size.width.decimal
    },
    {
      ...ColumnName.CoolantSample.boilPoint,
      cell: Kendo.cellTemplateNames.severity,
      display: ColumnName.CoolantSample.boilPointDisplay.field,
      filter: Kendo.filter.numeric,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.decimal
    },
    {
      ...ColumnName.CoolantSample.tds,
      cell: Kendo.cellTemplateNames.severity,
      display: ColumnName.CoolantSample.tdsDisplay.field,
      filter: Kendo.filter.numeric,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.decimal
    },
    {
      ...ColumnName.CoolantSample.freezePoint,
      cell: Kendo.cellTemplateNames.severity,
      display: ColumnName.CoolantSample.freezePointDisplay.field,
      filter: Kendo.filter.numeric,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: true,
      selectedLargeView: true,
      width: Kendo.size.width.int
    },
    {
      ...ColumnName.CoolantSample.antifreezePercent,
      cell: Kendo.cellTemplateNames.severity,
      filter: Kendo.filter.numeric,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: true,
      selectedLargeView: true,
      width: Kendo.size.width.int
    },
    {
      ...ColumnName.CoolantSample.hardness,
      cell: Kendo.cellTemplateNames.severity,
      display: ColumnName.CoolantSample.hardnessDisplay.field,
      filter: Kendo.filter.numeric,
      minResizableWidth: Kendo.size.minResizableWidth,
      selectedLargeView: true,
      width: Kendo.size.width.int
    },
    {
      ...ColumnName.CoolantSample.odor,
      cell: Kendo.cellTemplateNames.severity,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.default
    },
    // TODO: MagneticPrecipitateResult
    {
      ...ColumnName.CoolantSample.specificConductance,
      cell: Kendo.cellTemplateNames.severity,
      display: ColumnName.CoolantSample.specificConductanceDisplay.field,
      filter: Kendo.filter.numeric,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.int
    },
    // TODO: OilResult
    // TODO: NonMagneticPrecipitateResult
    {
      ...ColumnName.CoolantSample.foam,
      cell: Kendo.cellTemplateNames.severity,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.CoolantSample.fuel,
      cell: Kendo.cellTemplateNames.severity,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.CoolantSample.chloride,
      cell: Kendo.cellTemplateNames.severity,
      display: ColumnName.CoolantSample.chlorideDisplay.field,
      filter: Kendo.filter.numeric,
      minResizableWidth: Kendo.size.minResizableWidth,
      selectedLargeView: true,
      width: Kendo.size.width.int
    },
    {
      ...ColumnName.CoolantSample.nitrate,
      cell: Kendo.cellTemplateNames.severity,
      display: ColumnName.CoolantSample.nitrateDisplay.field,
      filter: Kendo.filter.numeric,
      minResizableWidth: Kendo.size.minResizableWidth,
      selectedLargeView: true,
      width: Kendo.size.width.int
    },
    {
      ...ColumnName.CoolantSample.nitrite,
      cell: Kendo.cellTemplateNames.severity,
      display: ColumnName.CoolantSample.nitriteDisplay.field,
      filter: Kendo.filter.numeric,
      minResizableWidth: Kendo.size.minResizableWidth,
      selectedLargeView: true,
      width: Kendo.size.width.int
    },
    {
      ...ColumnName.CoolantSample.phosphate,
      cell: Kendo.cellTemplateNames.severity,
      display: ColumnName.CoolantSample.phosphateDisplay.field,
      filter: Kendo.filter.numeric,
      minResizableWidth: Kendo.size.minResizableWidth,
      selectedLargeView: true,
      width: Kendo.size.width.int
    },
    {
      ...ColumnName.CoolantSample.sulfate,
      cell: Kendo.cellTemplateNames.severity,
      display: ColumnName.CoolantSample.sulfateDisplay.field,
      filter: Kendo.filter.numeric,
      minResizableWidth: Kendo.size.minResizableWidth,
      selectedLargeView: true,
      width: Kendo.size.width.int
    },
    {
      ...ColumnName.CoolantSample.oxalate,
      cell: Kendo.cellTemplateNames.severity,
      display: ColumnName.CoolantSample.oxalateDisplay.field,
      filter: Kendo.filter.numeric,
      minResizableWidth: Kendo.size.minResizableWidth,
      selectedLargeView: true,
      width: Kendo.size.width.int
    },
    {
      ...ColumnName.CoolantSample.acetate,
      cell: Kendo.cellTemplateNames.severity,
      display: ColumnName.CoolantSample.acetateDisplay.field,
      filter: Kendo.filter.numeric,
      minResizableWidth: Kendo.size.minResizableWidth,
      selectedLargeView: true,
      width: Kendo.size.width.int
    },
    {
      ...ColumnName.CoolantSample.formate,
      cell: Kendo.cellTemplateNames.severity,
      display: ColumnName.CoolantSample.formateDisplay.field,
      filter: Kendo.filter.numeric,
      minResizableWidth: Kendo.size.minResizableWidth,
      selectedLargeView: true,
      width: Kendo.size.width.int
    },
    {
      ...ColumnName.CoolantSample.glycolate,
      cell: Kendo.cellTemplateNames.severity,
      display: ColumnName.CoolantSample.glycolateDisplay.field,
      filter: Kendo.filter.numeric,
      minResizableWidth: Kendo.size.minResizableWidth,
      selectedLargeView: true,
      width: Kendo.size.width.int
    },
    {
      ...ColumnName.CoolantSample.fluoride,
      cell: Kendo.cellTemplateNames.severity,
      display: ColumnName.CoolantSample.fluorideDisplay.field,
      filter: Kendo.filter.numeric,
      minResizableWidth: Kendo.size.minResizableWidth,
      selectedLargeView: true,
      width: Kendo.size.width.int
    },
    {
      ...ColumnName.CoolantSample.elcPassFail,
      cell: Kendo.cellTemplateNames.severity,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.CoolantSample.billingThirdParty,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.CoolantSample.billingDescription,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.CoolantSample.isBillable,
      filter: Kendo.filter.boolean,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.boolean
    },
    {
      ...ColumnName.CoolantSample.isBillingBasicSample,
      filter: Kendo.filter.boolean,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.boolean
    },
    {
      ...ColumnName.CoolantSample.isBillingNC,
      filter: Kendo.filter.boolean,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.boolean
    },
    {
      ...ColumnName.CoolantSample.isBillingNOB,
      filter: Kendo.filter.boolean,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.boolean
    },
    {
      ...ColumnName.CoolantSample.isBillingRUSH,
      filter: Kendo.filter.boolean,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.boolean
    },
    {
      ...ColumnName.CoolantSample.isBillingST,
      filter: Kendo.filter.boolean,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.boolean
    },
    {
      ...ColumnName.CoolantSample.isBillingPT,
      filter: Kendo.filter.boolean,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.boolean
    },
    {
      ...ColumnName.CoolantSample.modifiedOn,
      filter: Kendo.filter.date,
      filterable: false,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.date
    },
    {
      ...ColumnName.CoolantSample.createdOn,
      filter: Kendo.filter.date,
      filterable: false,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.date
    }
  ],
  doClientSide: false,
  filter: {
    logic: 'and',
    filters: []
  },
  paging: {
    pageSize: 10,
    skip: 0,
    take: 10
  },
  searchHeader: 'Search Coolant Samples',
  searchPlaceholder: 'Enter keywords...',
  sort: [],
  title: 'Coolant Samples Grid'
};
